import store from "lib/store";

function getSelectedIdClinic() {
  return store.getState().clinics.selected?._id;
}

export default getSelectedIdClinic;
